import React from "react"
import { Controller } from "react-hook-form"
import {
  Switch,
  FormLabel,
  FormControlLabel,
  FormControl,
} from "@fedsim/components"

export const FormToggle = ({ name, control, label = "", size = "small" }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <FormControl fullWidth component='fieldset'>
          <FormLabel component='legend'>{label}</FormLabel>
          <FormControlLabel
            label={label}
            control={
              <Switch
                size={size}
                inputProps={{ "aria-label": "checkbox" }}
                onChange={onChange}
                checked={Boolean(value)}
              />
            }
          />
        </FormControl>
      )}
    />
  )
}
